// extracted by mini-css-extract-plugin
export default {"skipStep":"skipStep__uk1_j1vTA5wa"};